"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// export something to force webpack to see this as an ES module
var TYPES = exports.TYPES = true;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cross-domain-utils/dist/module/types.js
// module id = 298
// module chunks = 2